import styled from "styled-components";
import { theme } from "../../configuration";

const HelpResultCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  flex-basis: 190px;
  width: 190px;
  height: auto;
  padding: ${props => props.padding ? props.padding : `10px`};
  border-radius: 15px;
  margin: 20px 0px 20px 0px;
  cursor: pointer;
  
  @media (max-width: ${theme.pageWidthForSingleColumnHelpResults}) {
    padding: ${props => props.paddingNarrow ? props.paddingNarrow : `10px`};
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    width: auto;
    margin: 0px;
  }
  
  &:hover {
    background-color: #dfead2;
  }
`;

export default HelpResultCard;
